import { type ReactNode } from "react";
import { type RequireAtLeastOne } from "@custom-types/index";

type RequiredFileds = RequireAtLeastOne<{ content: ReactNode; children: ReactNode }>;

export type TooltipProps = {
	target: string;
	position?: TooltipPosition;
	autoHide?: boolean;
	showOnDisabled?: boolean;
} & RequiredFileds;

export enum TooltipPosition {
	Top = "top",
	Right = "right",
	Bottom = "bottom",
	Left = "left",
}
